/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * Tooltip component.
 *
 * Component that provides a tooltip popup.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-tooltip',
})
export default class Tooltip extends Vue {
    @Prop(String) public field!: string;
    @Prop(String) public description!: string;
}

